import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ErrorPage from '@rsos/components/capstone/ErrorPage';
import { AppInnerWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import AppLoading from '@rsos/components/capstone/Layout/AppLoading';
import Dashboard from '../components/Dashboard';
import { persistor } from '../store';
import { initialize } from './appSlice';

const useInitialize = dispatch => {
  useEffect(() => {
    (async () => {
      const action = await dispatch(initialize());
      if (action && action.error) {
        throw new Error(action.error);
      }
    })();
  }, [dispatch]);
};

// ADD A TODO
const App = () => {
  const dispatch = useDispatch();
  const { initialized, initializing, initError } = useSelector(
    state => state.appAlertsRouting,
  );
  useInitialize(dispatch);
  return useMemo(() => {
    if (initError) {
      return <ErrorPage persistor={persistor} />;
    }

    if (initializing) {
      return <AppLoading />;
    }

    if (initialized) {
      return (
        <AppInnerWrapper>
          <Dashboard />
        </AppInnerWrapper>
      );
    }

    return <ErrorPage persistor={persistor} />;
  }, [initialized, initializing, initError]);
};

export default App;
